import {HomepageDynamic} from "../src/homepage/HomepageDynamic";
import {prepareHydratedApp} from "./utils/prepare_hydrate_app";

/** Default / fallback entry — keep light (no dashboard/edit/login). */
const config = [{reactDynamic: "homepage", view: <HomepageDynamic />}];

(() => prepareHydratedApp(config))();
